// src/pages/racks/index.js
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchRacksList } from "./racksThunks";
import { Button, Grid, Typography } from "antd";
import { ArrowLeftOutlined,} from "@ant-design/icons";
import RacksList from "./components/RacksList";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const Racks = () => {
  const dispatch = useDispatch();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { racks } = useSelector((state) => state.racks);

  const navigate =useNavigate();
  const handleNavigateToBack = () => {
  navigate("/inventory/dashboard");
  };
	

  useEffect(() => {
    dispatch(fetchRacksList());
  }, [dispatch]);

  return (
    <>
      <div
				style={{
				  display: "flex",
				  alignItems: "center",
				  marginBottom: "24px",
				}}
			  >
				<Button
				  type="text"
				  icon={<ArrowLeftOutlined style={{ fontSize: !screens.md ? "18px" : "22px" }} />} // ✅ Scaled to match Title
			      onClick={handleNavigateToBack}
				  style={{
					marginRight: 12,
					padding: 0,
					height: "auto",
					lineHeight: "1",
					color: "#000", // optional, keeps consistent with text color
				  }}
				/>
				<Title
					level={!screens.md ? 4 : 2}
					style={{
						margin : 0,
						whiteSpace: "normal",
						wordBreak: "break-word",
						textAlign: !screens.md ? "center" : "left",
					}}
				>
				  Items Racks List
				</Title>
			  </div>
      <RacksList racksList={racks} />
    </>
  );
};

export default Racks;
